/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Precomfort_Timeslot_Generation_HelpInputs */



/**
* | output |
* | --- |
* | "Generation of pre-comfort time slots during irregular presence" |
*
* @param {Precomfort_Timeslot_Generation_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const precomfort_timeslot_generation_help = /** @type {((inputs?: Precomfort_Timeslot_Generation_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Precomfort_Timeslot_Generation_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Generation of pre-comfort time slots during irregular presence")
	return /** @type {LocalizedString} */ ("Génération de plages horaires de pré-confort lors d'une présence irrégulière")
});